import { acceptHMRUpdate, defineStore } from 'pinia'

export const whitelabelsStore = defineStore('whitelabels', {
	namespaced: true,
	state: () => ({
		auroraEnergy: {
			heroImage: 'img/partners/auroraenergy/img-hero-auroraenergy.webp',
			heroImageMobile:
				'img/partners/auroraenergy/img-hero-auroraenergy-mobile.webp',
			partnerLogo: 'img/partners/auroraenergy/logo-auroraenergy.webp',
			partnerLogoAltText: 'Aurora Energy',
			partnerName: 'Aurora Energy',
			menuItemsColor: 'text-gray-700 hover:text-auroraenergy-primarydark',
			menuItemFontWeight: 'font-semibold',
			iconColorHover: 'group-hover:text-auroraenergy-primarydark',

			styles: {
				bg: {
					borderRadius: 'rounded-lg',
					color: 'bg-auroraenergy-primary',
				},
				text: 'text-auroraenergy-primary',
				button: {
					bg: 'bg-auroraenergy-primary hover:bg-auroraenergy-primarydark',
					outline:
						'hover:border-auroraenergy-primarydark group border duration-300 ease-out',
					outlineText:
						'hover:text-auroraenergy-primarydark group duration-300 ease-out',
					font: 'font-campton font-semibold',
					text: 'text-auroraenergy-primary hover:text-auroraenergy-primarydark',
					hover: 'hover:text-auroraenergy-primarydark',
					underline: 'hover:decoration-auroraenergy-primarydark',
					borderRadius: 'rounded-full',
				},
				tickIcon: {
					color: 'text-auroraenergy-primary',
				},
			},
			links: {
				partnerUrl: '/partners/auroraenergy',
				signInUrl: '/partners/auroraenergy/sign-in',
				signUpUrl: '/partners/auroraenergy/sign-up',
				forgotPasswordUrl: '/partners/auroraenergy/forgot-password',
				resetPasswordUrl: '/partners/auroraenergy/reset-password',
				faqUrl: 'https://support.carbar.com.au/subscribe-a-car',
			},
		},

		sonnenDrive: {
			heroImage: 'img/partners/sonnendrive/img-hero-sonnendrive.webp',
			heroImageMobile:
				'img/partners/sonnendrive/img-hero-sonnendrive-mobile.webp',
			partnerLogo: 'img/partners/sonnendrive/logo-sonnendrive.webp',
			partnerLogoAltText: 'sonnenDrive',
			partnerName: 'sonnenDrive',
			menuItemsColor: 'text-gray-700 hover:text-sonnendrive-primarydark',
			menuItemFontWeight: 'font-semibold',
			iconColorHover: 'group-hover:text-sonnendrive-primarydark',

			styles: {
				bg: {
					borderRadius: 'rounded-lg',
					color: 'bg-sonnendrive-primary',
				},
				text: 'text-sonnendrive-primary',
				button: {
					bg: 'bg-sonnendrive-primary hover:bg-sonnendrive-primarydark',
					bgInvert: 'bg-white hover:bg-gray-100',
					outline:
						'border-gray-600 hover:border-sonnendrive-primarydark group border duration-300 ease-out',
					outlineText:
						'hover:text-sonnendrive-primarydark group duration-300 ease-out',
					font: 'font-campton font-semibold',
					text: 'text-sonnendrive-primary hover:text-sonnendrive-primarydark',
					hover: 'hover:text-sonnendrive-primarydark',
					underline: 'hover:decoration-sonnendrive-primarydark',
					borderRadius: 'rounded',
					shadow: '',
				},
				tickIcon: {
					color: 'text-sonnendrive-primary',
				},
			},
			links: {
				partnerUrl: '/partners/sonnendrive',
				signInUrl: '/partners/sonnendrive/sign-in',
				signUpUrl: '/partners/sonnendrive/sign-up',
				forgotPasswordUrl: '/partners/sonnendrive/forgot-password',
				resetPasswordUrl: '/partners/sonnendrive/reset-password',
				faqUrl: 'https://support.carbar.com.au/subscribe-a-car',
			},
		},

		carsales: {
			heroImage: 'img/partners/carsales/img-hero-auroraenergy.webp',
			heroImageMobile:
				'img/partners/carsales/img-hero-auroraenergy-mobile.webp',
			partnerLogo: 'img/partners/carsales/logo-carsales.webp',
			partnerLogoAltText: 'carsales',
			partnerName: 'carsales',
			menuItemsColor: 'text-gray-700 hover:text-carsales-primarydark',
			menuItemFontWeight: 'font-semibold',
			iconColorHover: 'group-hover:text-carsales-primarydark',

			styles: {
				bg: {
					borderRadius: 'rounded-xl',
					color: 'bg-carsales-primary',
				},
				text: 'text-carsales-primary',
				outline: 'hover:outline-carsales-primary',
				button: {
					bg: 'bg-carsales-primary hover:bg-carsales-primarydark',
					bgInvert: 'bg-white hover:bg-gray-100',
					outline:
						'border border-gray-400 hover:border-carsales-primarydark',
					outlineText:
						'hover:text-carsales-primarydark duration-300 ease-out',
					font: 'font-semibold',
					text: 'text-carsales-primary hover:text-carsales-primarydark',
					icon: 'stroke-carsales-primary hover:stroke-carsales-primarydark',
					hover: 'hover:text-carsales-primarydark',
					underline: 'hover:decoration-carsales-primarydark',
					borderRadius: 'rounded-xl',
				},
				tickIcon: {
					color: 'text-carsales-primary',
				},
			},
			links: {
				partnerUrl: '/partners/carsales',
				signInUrl: '/partners/carsales/sign-in',
				signUpUrl: '/partners/carsales/sign-up',
				verifyOtpUrl: '/partners/carsales/verify-otp',
				forgotPasswordUrl: '/partners/carsales/forgot-password',
				resetPasswordUrl: '/partners/carsales/reset-password',
				browseUrl: '/partners/carsales/browse',
				aboutUrl: '/partners/carsales/about-us',
				howItWorksUrl: '/partners/carsales/how-it-works',
				faqUrl: 'https://support.carbar.com.au/subscribe-a-car',
			},
		},

		erinLiving: {
			heroImage: 'img/partners/erinliving/img-hero-auroraenergy.webp',
			heroImageMobile:
				'img/partners/erinliving/img-hero-auroraenergy-mobile.webp',
			partnerLogo: 'img/partners/erinliving/logo-carsales.webp',
			partnerLogoAltText: 'Erin Living',
			partnerName: 'Erin Living',
			partnerLogoImageClass: 'min-h-8 h-8 min-w-[80px] w-auto md:h-10',
			menuItemsColor: 'text-gray-700 hover:text-erinliving-primarydark',
			menuItemFontWeight: 'font-semibold',
			iconColorHover: 'group-hover:text-erinliving-primarydark',

			styles: {
				bg: {
					borderRadius: 'rounded-xl',
					color: 'bg-erinliving-primary',
				},
				outline: 'hover:outline-erinliving-primary',
				text: 'text-erinliving-primary',
				textlight: 'text-erinliving-primarylight',
				button: {
					bg: 'bg-erinliving-primarylight hover:bg-erinliving-primary',
					bgInvert:
						'bg-erinliving-invert hover:bg-erinliving-invertdark',
					outline:
						'border border-gray-400 hover:border-erinliving-primary',
					outlineText:
						'hover:text-erinliving-primarydark duration-300 ease-out',
					font: 'font-campton font-semibold',
					text: 'text-erinliving-primary hover:text-erinliving-primarydark',
					icon: 'stroke-erinliving-primary hover:stroke-erinliving-primarydark',
					hover: 'hover:text-erinliving-primarydark',
					underline: 'hover:decoration-erinliving-primarydark',
					borderRadius: 'rounded-lg',
				},
				tickIcon: {
					color: 'text-erinliving-primary',
				},
			},
			links: {
				partnerUrl: '/partners/erinliving',
				signInUrl: '/partners/erinliving/sign-in',
				signUpUrl: '/partners/erinliving/sign-up',
				verifyOtpUrl: '/partners/erinliving/verify-otp',
				forgotPasswordUrl: '/partners/erinliving/forgot-password',
				resetPasswordUrl: '/partners/erinliving/reset-password',
				browseUrl: '/partners/erinliving/browse',
				aboutUrl: '/partners/erinliving/about-us',
				howItWorksUrl: '/partners/erinliving/how-it-works',
				faqUrl: 'https://support.carbar.com.au/subscribe-a-car',
			},
		},
	}),

	getters: {
		getAuroraEnergyStyles(state) {
			return state.auroraEnergy
		},
		getSonnenDriveStyles(state) {
			return state.sonnenDrive
		},
		getCarsalesStyles(state) {
			return state.carsales
		},
		getErinLivingStyles(state) {
			return state.erinLiving
		},
	},
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(whitelabelsStore, import.meta.hot))
}
